"use strict";
/// <reference path="../types/jest.d.ts" />
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupJestHooks = setupJestHooks;
exports.setMaxTickJump = setMaxTickJump;
exports.getMaxTickJump = getMaxTickJump;
exports.timeWarpTo = timeWarpTo;
exports.timeWarpTo2017 = timeWarpTo2017;
exports.timeWarpForward = timeWarpForward;
exports.resetTimers = resetTimers;
exports.endTimeWarp = endTimeWarp;
exports.getTimeWarpClock = getTimeWarpClock;
/**
 * Wrapper around sinonjs/fake-timers, which provides mocking of current time.
 *
 * Based on a same-named BA test utility.
 */
const fake_timers_1 = __importDefault(require("@sinonjs/fake-timers"));
const TimeUnit_1 = require("../TimeUnit");
// Omitting things like setImmediate, RAF that fire very quickly.
const methodsToFake = [
    "setTimeout",
    "clearTimeout",
    "setInterval",
    "clearInterval",
    "Date",
    "hrtime",
];
let clock;
/**
 * Global jest hook to ensure TimeWarp cleans up after every test.
 * Most effective when used with the Jest function setupFilesAfterEnv()
 * https://jestjs.io/docs/configuration#setupfilesafterenv-array
 */
function setupJestHooks() {
    afterEach(() => {
        endTimeWarp();
    });
}
let maxTickJump = 1000 * TimeUnit_1.timeUnitTable.sec;
/**
 * Sets the max amount of time clock is allowed to jump through tick().
 * Default is 1000 seconds. This function takes in a value of milliseconds
 * that is automatically converted to seconds.
 * @param {number} milliseconds
 */
function setMaxTickJump(milliseconds) {
    maxTickJump = milliseconds * TimeUnit_1.timeUnitTable.sec;
}
/**
 * Gets the max amount of time clock is allowed to jump through tick().
 * Time unit is in seconds.
 */
function getMaxTickJump() {
    return maxTickJump;
}
/**
 * Pass a function that takes current timestamp and can return a new one. Both
 * the parameter and return should be numbers, a unix timestamp including
 * milliseconds. This updates the current clock to use that as the current
 * time, installing the fake clock if there isn't one already.
 */
function timeWarpTo(f) {
    const oldTime = Date.now();
    let newTime = f(oldTime);
    if (typeof newTime !== "number" && newTime.valueOf) {
        newTime = newTime.valueOf();
    }
    if (!clock) {
        clock = fake_timers_1.default.install({ now: newTime, toFake: methodsToFake });
    }
    else if (newTime < oldTime) {
        clock.setSystemTime(newTime);
    }
    else if (newTime > oldTime + maxTickJump) {
        clock.setSystemTime(newTime);
    }
    else {
        clock.tick(newTime - oldTime);
    }
}
/**
 * timeWarpTo that sets the time to noon, New Years, 2017. It is 2017 because
 * that is when the original utility was written for BA. It is 12 noon UTC
 * in order to avoid timezones changing the date. Provided as a convenience
 * for when you want a fixed time and don't care what it is.
 */
function timeWarpTo2017() {
    timeWarpTo(() => Date.UTC(2017, 0, 1, 12));
}
/**
 * timeWarpTo convenience form that advances by the given amount written as a
 * number and unit. See the docs on timeUnitTable (also in this package) for
 * available units.
 */
function timeWarpForward(amt, unit) {
    timeWarpTo((t) => t + (0, TimeUnit_1.resolveTimeUnit)(amt, unit));
}
/**
 * Reset all timer callbacks while leaving the timer installed. The
 * fake now value is unchanged. Noops if TimeWarp wasn't used.
 */
function resetTimers() {
    if (clock) {
        const now = Date.now();
        clock.reset();
        clock.setSystemTime(now);
    }
}
/**
 * Make all timer functions, including the current time, go back to normal.
 * Noops if TimeWarp wasn't used.
 */
function endTimeWarp() {
    if (clock)
        clock.uninstall();
    clock = undefined;
}
/**
 * Get the currently installed clock, or undefined if there is none.
 */
function getTimeWarpClock() {
    return clock;
}
//# sourceMappingURL=TimeWarp.js.map